// extracted by mini-css-extract-plugin
module.exports = {"scrollToTop":"ScrollToTop_scrollToTop__7NKxR","dark":"ScrollToTop_dark__YAflW"};